import { render, staticRenderFns } from "./Defaulter.vue?vue&type=template&id=f1293e40&scoped=true&"
import script from "./Defaulter.vue?vue&type=script&lang=js&"
export * from "./Defaulter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1293e40",
  null
  
)

export default component.exports